import React from "react";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { ptBR } from "date-fns/locale";
import { ptBR as pickersPtBR } from "@mui/x-date-pickers/locales";

interface ILocalizationProviderCustom {
  children: React.ReactNode;
}

export const LocalizationProviderCustom: React.FC<
  ILocalizationProviderCustom
> = ({ children }) => {
  return (
    <LocalizationProvider
      dateAdapter={AdapterDateFns}
      adapterLocale={ptBR}
      localeText={
        pickersPtBR.components.MuiLocalizationProvider.defaultProps.localeText
      }
    >
      {children}
    </LocalizationProvider>
  );
};
